import slugify from 'slugify';
import { ISortOption } from '~/store/types';

export const getOptionSlug = (sortOption: ISortOption | { title: any }) =>
  slugify(sortOption.title.replace(':', '')).toLowerCase();
